export enum MealRelation {
    AfterFood = 1,
    BeforeFood = 2,
    WithFood = 3,
    EmptyStomach = 4,
}

export const MealRelationLabels: Record<MealRelation, string> = {
    [MealRelation.AfterFood]: "After Food",
    [MealRelation.BeforeFood]: "Before Food",
    [MealRelation.WithFood]: "With Food",
    [MealRelation.EmptyStomach]: "Empty Stomach",
};